import React, { useCallback, useEffect, useState } from "react";
import { render } from 'react-dom';
import { DropdownMenu } from "./DropdownMenu";
import { MegaMenu } from "./MegaMenu";

(function init() {
  function loadComponent() {
    const rootElement = document.querySelector('[data-desktop-menu]');
    if (rootElement) render(<DesktopMenu />, rootElement);
  }

  document.addEventListener("shopify:section:load", loadComponent);
  loadComponent();
})();

function DesktopMenu() {
  const menu = JSON.parse(document.querySelector('[data-menu]').innerHTML);
  const [activeDropdown, setActiveDropdown] = useState(null);

  /*
    Event handlers
  */

  // If clicked dropdown matches current index clear the active dropdown, else set the new index of dropdown
  const handleDropdownClick = useCallback((index) => {
    setActiveDropdown((prev) => prev !== index ? index : null);      
  }, []);

  useEffect(() => {
    // If there's a click on the document and 1) there's an open dropdown and 2) the target is not a trigger and doesn't have a parent that's a data-dropdown-parent, then close all dropdowns
    document.addEventListener('click', (e) => {
      const open = document.querySelector('[data-dropdown-trigger][aria-expanded="true"]');
      if (typeof open != "undefined" && open != null) {
        if (
          !e.target.hasAttribute('data-dropdown-trigger') && 
          e.target.closest('[data-dropdown-parent]') === null
        ) {
          setActiveDropdown(null);
        }
      }
    });

    // If there's an open dropdown and the escape key is pressed, close all dropdowns and return focus to trigger
    document.addEventListener('keyup', (e) => {
      const open = document.querySelector('[data-dropdown-trigger][aria-expanded="true"]');
      if (e.key === 'Escape' && (typeof open != "undefined" && open != null)) {
        const trigger = document.querySelector(`[data-dropdown-trigger="DropdownTrigger-${activeDropdown}"]`);
        if (trigger) trigger.focus();
        setActiveDropdown(null);
      }
    });
  }, []);

  useEffect(() => {
    if (activeDropdown !== null) {
      document.getElementById("HeaderOverlay").classList.remove('opacity-0', 'invisible');
    } else {
      document.getElementById("HeaderOverlay").classList.add('opacity-0', 'invisible');
    }
  }, [activeDropdown])

  if (menu.length === 0) {
    return null;
  }

  return (
    <ul 
      className="list-none flex items-center justify-center gap-10 text-[0.875rem] font-medium uppercase" role="list"
    >
      {menu.map((item, index) => {
        if ('content' in item) {
          return (
            <li className="list-none" key={index}>
              <MegaMenu item={item} index={index} open={index === activeDropdown} handleDropdownClick={handleDropdownClick} setActiveDropdown={setActiveDropdown} />
            </li>
          )
        } else {
          if ('links' in item) {
            return (
              <li className="list-none" key={index}>
                <DropdownMenu item={item} index={index} open={index === activeDropdown} handleDropdownClick={handleDropdownClick} setActiveDropdown={setActiveDropdown} />
              </li>
            )
          }
          return (
            <li className="list-none" key={index}>
              <a href={item.url} 
                className={`inline-block py-4 underline underline-offset-4 decoration-transparent hover:decoration-black transition uppercase ${item.current && `decoration-black`}`}
                aria-current={item.current}>
                <span>{item.title}</span>
              </a>
            </li>
          )
        }
      })}
    </ul>
  )
}